export default __webpack_public_path__ + "static/media/googleIcon.7b76b92b.svg";